import React, { useRef } from "react";
import ModalContent from "src/Shared/Components/ModalContent/ModalContent";
import AddComments, { AddCommentsRef } from "../AddComments/AddComments";
import { useStore } from "src/Shared/Hooks";
import { observer } from "mobx-react";

type Props = {
  companyRowID: string;
  isSlaRelated: boolean;
};

const CompanyComments: React.FC<Props> = ({ companyRowID, isSlaRelated }) => {
  const formRef = useRef<AddCommentsRef>(null);

  const {
    rootStore: {
      addCommentStore: { btnLoading },
    },
  } = useStore();
  return (
    <ModalContent
      buttonText="Add new comment"
      title={(isSlaRelated ? "SLA Related " : "") + "Comments"}
      onSaveButtonClick={() => formRef.current?.submitForm()}
      btnLoading={btnLoading}
    >
      {btnLoading}
      <AddComments
        ref={formRef}
        companyRowID={companyRowID}
        isSlaRelated={isSlaRelated}
      />
    </ModalContent>
  );
};

export default observer(CompanyComments);
